
<template>
    <div class="container " @click="goBackHome" title="回到首页">
      <img :src="src" alt="">
    </div>
</template>

<script>
  import goBackIcon from "../../../static/img/goHome.png";
  export default {
    name: '',
    data() {
      return {
        src: goBackIcon,
      }
    },
    methods: {
      goBackHome () {
        this.$router.push("/school")
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .container {
      position: fixed;
      bottom: 70px;
      right: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/components/basic/GoHome.vue